import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';

import Appearance from 'styles/Appearance.js';
import { CollapseArrow } from 'structure/Layer.js';
import TextField from 'views/TextField.js';
import { ViewRow } from 'views/Main.js';

const TimezoneLookupField = ({ containerStyle, defaultValue, onChange, value }) => {

    const items = useRef(moment.tz.names());
    const [collapsed, setCollapsed] = useState(true);
    const [results, setResults] = useState([]);
    const [text, setText] = useState(defaultValue || value);

    const onClick = result => {
        setText(result);
        setResults([]);
        if(typeof(onChange) === 'function') {
            onChange(result);
        }
    }

    const onCollapsArrowClick = () => {

        // update flag for collapsed arrow
        setCollapsed(!collapsed);

        // show all items if expanding list
        if(collapsed) {
            setResults(items.current);
            setText(null);
            return;
        }

        // reset list to default state        
        setResults([]);
        setText(null);
    }

    const onTextChange = text => {
        let term = text.toLowerCase();
        setText(text);
        setResults(items.current.filter(item => item.replace('_', ' ').toLowerCase().includes(term)));
    }

    useEffect(() => {
        value && setText(value);
    }, [value]);

    return (
        <div style={{
            width: '100%',
            ...containerStyle
        }}>
            <TextField
            appendContent={(
                <CollapseArrow
                collapsed={collapsed}
                onClick={onCollapsArrowClick} />
            )}
            onChange={onTextChange}
            placeholder={'Search for a timezone...'}
            value={text} />
            {results.length > 0 && (
                <div style={{
                    borderColor: Appearance.colors.softBorder(),
                    borderRadius: 12,
                    borderStyle: 'solid',
                    borderWidth: 1,
                    maxHeight: 350,
                    marginBottom: 12,
                    marginTop: 8,
                    overflowY: 'scroll',
                    padding: 0,
                    textAlign: 'left'
                }}>
                    {results.map((timezone, index) => {
                        return (
                            <ViewRow
                            key={index}
                            bottomBorder={index !== results.length - 1}
                            label={timezone}
                            onClick={onClick.bind(this, timezone)} />
                        )
                    })}
                </div>
            )}
        </div>
    )
}
export default TimezoneLookupField;
